import { gql } from '@apollo/client';

export const UPDATE_TRAJECTORY_MODEL = gql`
    mutation updateTrajectoryModel($input: UpdateTrajectoryConfigurationInput!) {
        facility {
            modelConfigurations {
                trajectoryConfigurations {
                    updateTrajectoryConfiguration(input: $input) {
                        id
                        name
                        description
                        type
                        isBlasting
                        runs {
                            id
                            key
                        }
                        calmetConfigurations {
                            id
                            name
                            description
                            sourceForTypes
                            timeStep
                            isForecast
                        }
                    }
                }
            }
        }
    }
`;
